import GoogleAccessToken, {
  GoogleAccessTokenDeserializationError,
} from './GoogleAccessToken';

const GOOGLE_ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'F5avCMUMjXyv3rUIY2pGz02Dl';

class GoogleAccessTokenStore {
  private accessToken: GoogleAccessToken | null = null;

  getAccessToken(): GoogleAccessToken | null {
    return this.accessToken ?? this.getAccessTokenFromLocalStorage();
  }

  setAccessToken(accessToken: GoogleAccessToken): void {
    if (accessToken === this.accessToken) {
      return;
    }

    this.persistAccessTokenInLocalStorage(accessToken);

    this.accessToken = accessToken;
  }

  clearAccessToken(): void {
    localStorage.removeItem(GOOGLE_ACCESS_TOKEN_LOCAL_STORAGE_KEY);

    this.accessToken = null;
  }

  private getAccessTokenFromLocalStorage(): GoogleAccessToken | null {
    const serializedAccessToken = localStorage.getItem(
      GOOGLE_ACCESS_TOKEN_LOCAL_STORAGE_KEY,
    );

    if (serializedAccessToken === null) {
      return null;
    }

    try {
      return GoogleAccessToken.fromSerialized(
        JSON.parse(serializedAccessToken),
      );
    } catch (error) {
      if (
        error instanceof GoogleAccessTokenDeserializationError ||
        error instanceof SyntaxError
      ) {
        return null;
      }

      throw error;
    }
  }

  private persistAccessTokenInLocalStorage(
    accessToken: GoogleAccessToken,
  ): void {
    localStorage.setItem(
      GOOGLE_ACCESS_TOKEN_LOCAL_STORAGE_KEY,
      JSON.stringify(accessToken.serialize()),
    );
  }
}

const googleAccessTokenStore = new GoogleAccessTokenStore();

export default googleAccessTokenStore;
